import fetchNLSResults from '../util/fetchNLSResults';
import { makeAllLinkPath } from '../util/transformInventoryResults';

/**
 * Strategy for Natural Language Search without Condition Tabs
 * Fetches unified results without condition filtering
 */
export async function nlsWithoutConditionTabsStrategy({
	query,
	widgetSearchServiceUri,
	siteId,
	locale,
	device,
	pageAlias,
	windowId,
	widgetName,
	getPathByCondition,
	processSuggestions,
	pageSearchResults,
	vehicleOrder,
	prioritizeClosestVehicles,
	userPostalCode
}) {
	const inventorySrpPath = getPathByCondition('DEFAULT');

	const response = await fetchNLSResults(
		widgetSearchServiceUri,
		siteId,
		locale,
		device,
		pageAlias,
		windowId,
		widgetName,
		query,
		vehicleOrder,
		prioritizeClosestVehicles,
		userPostalCode,
		undefined
	);

	const { sortedSuggestions, transformedSuggestions } = processSuggestions(
		response,
		inventorySrpPath
	);

	const inventorySearchResponse = {
		...response,
		suggestions: transformedSuggestions,
		allVehiclesPath: makeAllLinkPath(
			sortedSuggestions,
			inventorySrpPath,
			transformedSuggestions,
			response?.nlsFacets
		)
	};

	return {
		inventorySearchResponse,
		pageSearchResponse: pageSearchResults
	};
}
